import { useEffect, useState } from 'react'

const DEMO_MODE_KEY = 'ecofarte_demo_mode'
const DEMO_MODE_EVENT = 'ecofarte-demo-mode-change'

export const DEMO_CLIENT_NAME = 'DEMOSTRACIÓN'
export const DEMO_GROUP_NAME = 'DEMO'

export function isDemoMode(): boolean {
  try {
    return localStorage.getItem(DEMO_MODE_KEY) === '1'
  } catch {
    return false
  }
}

export function setDemoMode(enabled: boolean): void {
  try {
    if (enabled) {
      localStorage.setItem(DEMO_MODE_KEY, '1')
    } else {
      localStorage.removeItem(DEMO_MODE_KEY)
    }
  } catch {
    // ignore
  }
  window.dispatchEvent(new Event(DEMO_MODE_EVENT))
}

export function toggleDemoMode(): boolean {
  const next = !isDemoMode()
  setDemoMode(next)
  return next
}

export function onDemoModeChange(callback: () => void): () => void {
  const handler = () => callback()
  window.addEventListener(DEMO_MODE_EVENT, handler)
  window.addEventListener('storage', handler)
  return () => {
    window.removeEventListener(DEMO_MODE_EVENT, handler)
    window.removeEventListener('storage', handler)
  }
}

export function useDemoMode(): boolean {
  const [enabled, setEnabled] = useState(isDemoMode())

  useEffect(() => onDemoModeChange(() => setEnabled(isDemoMode())), [])

  return enabled
}
